import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { getHolidayList } from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DeleteConfirmationModel } from "utils/helperComponent";
import { toastMessage } from "utils/toastMessage";
import * as XLSX from "xlsx";

const messageStyle = {
  width: "33%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const Main = () => {
  const ref = useRef();
  let sampleFile = `https://jkmsfa.s3.ap-south-1.amazonaws.com/public/1709118067605-0.6807324395596748.xlsx`;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [bulkUploadData, setBulkUploadData] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);

  const [Values, setValues] = useState({
    holidayDate: "",
    title: "",
    holidayType: "",
    region: [],
  });

  const [schemeErr, setschemeErr] = useState({
    title: false,
    holidayDate: false,
    holidayType: false,
    region: false,
  });

  const type = [
    { value: "PUBLIC", label: "PUBLIC" },
    { value: "REGIONAL", label: "REGIONAL" },
  ];

  const regionList = [
    { regionCode: 1682, name: "Nepal" },
    { regionCode: 1182, name: "GUWAHATI" },
    { regionCode: 1681, name: "Patna" },
    { regionCode: 3181, name: "DELHI" },
    { regionCode: 3281, name: "FARIDABAD" },
    { regionCode: 3381, name: "JALLANDHAR" },
    { regionCode: 3681, name: "JAIPUR" },
    { regionCode: 3682, name: "JODHPUR" },
    { regionCode: 3781, name: "KANPUR" },
    { regionCode: 3782, name: "MEERUT" },
    { regionCode: 3783, name: "VARANASI" },
    { regionCode: 5181, name: "H.BAD" },
    { regionCode: 5182, name: "VIJAYWADA" },
    { regionCode: 5381, name: "CHENNAI" },
    { regionCode: 5382, name: "Cochin" },
    { regionCode: 7181, name: "INDORE" },
    { regionCode: 1683, name: "RANCHI" },
    { regionCode: 7381, name: "MUMBAI" },
    { regionCode: 7382, name: "NAGPUR" },
    { regionCode: 7581, name: "AHMEDABAD" },
    { regionCode: 1181, name: "KOLKATTA" },
    { regionCode: 7182, name: "RAIPUR" },
    { regionCode: 7183, name: "JABALPUR" },
    { regionCode: 7184, name: "CUTTAK" },
    { regionCode: 5281, name: "BNGLR" },
    { regionCode: 3382, name: "CHANDIGARH" },
    { regionCode: 5282, name: "HUBLI" },
    { regionCode: 5383, name: "Coimbatore" },
    { regionCode: 7582, name: "RAJKOT" },
    { regionCode: 5384, name: "Madurai" }
  ];

  const { holidayDate, title, holidayType, region } = Values;

  const Validate = () => {
    let value = true;
    let err = {};

    if (title === "" || title === " ") {
      err.title = "Please Enter Holiday Name.";
      value = false;
    }

    if (holidayDate === "") {
      err.holidayDate = "Please Select Holiday date.";
      value = false;
    }

    if (holidayType === "") {
      err.holidayType = "Please Select Holiday Type.";
      value = false;
    }

    if (holidayType === "REGIONAL" && region.length === 0) {
      err.region = "Select Regions.";
      value = false;
    }

    setschemeErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const holidayList = await getHolidayList();
    setData(holidayList?.data);
    setMessage(holidayList?.message);
    setLoading(true);
    setTotalPages(holidayList?.totalPage ?? 1);
  }, [message]);

  const handelSubmit = async () => {
    if (!Validate()) return;
    let { holidayDate, title, holidayType, ...rest } = Values;
    let data =
      holidayType === "PUBLIC"
        ? { holidayDate, title, holidayType }
        : { ...Values };
    const response = await authAxios()({
      url: `/api/v1/holiday`,
      method: "POST",
      data,
    });
    setMessage(response?.data?.message);
    setOpenModal(false);
    setValues({
      holidayDate: "",
      title: "",
      holidayType: "",
      region: [],
    });
    toastMessage(response?.data?.message, "success");
  };

  const handelUpdate = async () => {
    if (!Validate()) return;
    let { holidayDate, title, holidayType, ...rest } = Values;
    let data =
      holidayType === "PUBLIC"
        ? { holidayDate, title, holidayType }
        : { ...Values };

    const response = await authAxios()({
      url: `/api/v1/holiday/${Values?.id}`,
      method: "PUT",
      data,
    });
    setMessage(response?.data?.message);
    setEditModal(false);
    setValues({
      holidayDate: "",
      title: "",
      holidayType: "",
      region: [],
    });
    toastMessage(response?.data?.message, "success");
  };

  const confirmDelete = async (id) => {
    console.log("idd", id);
    const response = await authAxios()({
      url: `/api/v1/holiday/${id}`,
      method: "DELETE",
    });
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handleChange = (e) => {
    setValues({
      ...Values,
      [e.target.name]: e.target.value.replace(/\s+/g, " "),
    });
  };

  const handleRegionChange = (data) => {
    const isRegionIncluded = region.some((region) => region.name === data.name);
    if (isRegionIncluded) {
      setValues((prevValues) => ({
        ...prevValues,
        region: prevValues.region.filter((item) => item.name !== data.name),
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        region: [...prevValues.region, data],
      }));
    }
  };

  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };

  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleKeyPress = (e) => {
    const allowedCharacters = /^[a-zA-Z\s]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  function excelDateToJSDate(serial) {
    // Number of milliseconds between 1900-01-01 and 1970-01-01
    const excelEpochOffset = 25569;
    const millisecondsPerDay = 24 * 60 * 60 * 1000;

    // Convert Excel serial number to milliseconds since 1970-01-01
    let milliseconds = (serial - excelEpochOffset) * millisecondsPerDay;

    // Construct Date object
    return new Date(milliseconds);
  }

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        console.log("json", JSON.stringify(json));

        json.forEach((item) => {
          item.DATE = excelDateToJSDate(item.DATE);
        });

        console.log("json", JSON.stringify(json));
        // setBulkUploadData(json);
        if (
          "HOLIDAY NAME" in json[0] &&
          "TYPE" in json[0] &&
          "DATE" in json[0]
        ) {
          console.log("JSON", JSON.stringify(json));
          let arr = [];
          for (let j of json) {
            arr.push({
              type: j.TYPE,
              name: j["HOLIDAY NAME"],
              date: j.DATE,
              regions: j?.REGIONS
                ? j?.REGIONS.split(",").map((region) => region.trim())
                : null,
            });
          }
          console.log(JSON.stringify(arr));
          // setCsvData(arr);
          setBulkUploadData(arr);
          return;
        } else {
          alert(
            `Uploaded CSV file is missing "Holiday Title" or "Type" or "Date" field.`
          );
          ref.current.value = "";
        }
      };
    }
  };

  const bulkUpload = async () => {
    if (
      bulkUploadData.length <= 0 ||
      bulkUploadData === undefined ||
      bulkUploadData === null
    ) {
      return toastMessage("Upload Excel first.", "error");
    }
    let data = bulkUploadData;
    const response = await authAxios()({
      url: `/api/v1/holiday/bulkupload`,
      method: "POST",
      data,
    });
    console.log("repos", response);
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setUploadModal(false);
  };

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Holiday Calendar
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "1rem",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            setOpenModal(true);
          }}
        >
          Add holiday
        </Button>

        <Button
          style={{ marginLeft: "2rem" }}
          onClick={() => setUploadModal(true)}
          variant="contained"
        >
          Bulk Upload
        </Button>
      </div>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    Title
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Holiday Type
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Date
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?.title}</TableCell>
                      <TableCell align="center">{d?.holidayType}</TableCell>
                      <TableCell align="center">
                        {moment.utc(d?.holidayDate).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="center">
                        <EditIcon
                          sx={{
                            cursor: "pointer",
                            color: "green",
                          }}
                          onClick={() => {
                            setValues({
                              holidayType: d?.holidayType,
                              holidayDate: moment
                                .utc(d?.holidayDate)
                                .format("YYYY-MM-DD"),
                              region: d?.region,
                              title: d?.title,
                              id: d?._id,
                            });
                            setEditModal(true);
                          }}
                        />
                        <DeleteIcon
                          sx={{
                            cursor: "pointer",
                            color: "red",
                          }}
                          onClick={() => handleDelete(d?._id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box sx={{ textAlign: "left", pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>
                      No Holiday List Avilable.
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>
            <Grid justifyContent={"center"} container p={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Grid>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      {isDeleteDialogOpen ? (
        <DeleteConfirmationModel
          onOpen={isDeleteDialogOpen}
          onClose={handleCloseDialog}
          confirmDelete={confirmDelete}
          deletedItemId={deletedItemId}
        />
      ) : null}

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setschemeErr({
            title: false,
            holidayDate: false,
            holidayType: false,
            region: false,
          });
          setValues({
            holidayDate: "",
            title: "",
            holidayType: "",
            region: [],
          });
        }}
      >
        <Box sx={messageStyle}>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", textDecoration: "underline" }}
          >
            Add Holiday
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Name</Typography>
              <TextField
                onChange={handleChange}
                value={title}
                sx={{ width: "50%" }}
                name="title"
                label="Holiday"
                variant="outlined"
                onKeyPress={handleKeyPress}
                error={schemeErr.title}
                helperText={schemeErr.title}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Type</Typography>
              <TextField
                select
                onChange={handleChange}
                value={holidayType}
                sx={{ width: "50%" }}
                name="holidayType"
                label="Type of holiday"
                variant="outlined"
                error={schemeErr.holidayType}
                helperText={schemeErr.holidayType}
              >
                {type.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {holidayType === "REGIONAL" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6">Select Regions</Typography>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={region}
                    sx={{ width: "50%" }}
                    // label="Select Regions"
                    renderValue={(region) => {
                      const data = region.map((n) => n.name);
                      return data.join(", ");
                    }}
                    name="region"
                    error={schemeErr.region}
                    helperText={schemeErr.region}
                  >
                    {regionList.map((r) => (
                      <div key={r.value} style={{ marginLeft: "1rem" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={region.some(
                                (item) => item.name === r.name
                              )}
                            />
                          }
                          label={r.name}
                          onChange={(event) => handleRegionChange(r)}
                        />
                      </div>
                    ))}
                  </Select>
                </div>
              </>
            ) : null}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Date</Typography>
              <TextField
                type={"date"}
                onChange={handleChange}
                sx={{ width: "50%" }}
                value={holidayDate}
                name="holidayDate"
                variant="outlined"
                error={schemeErr.holidayDate}
                helperText={schemeErr.holidayDate}
              />
            </div>

            <Box sx={{ m: 2, display: "flex", justifyContent: "space-evenly" }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setschemeErr({
                    title: false,
                    holidayDate: false,
                    holidayType: false,
                    region: false,
                  });
                  setValues({
                    holidayDate: "",
                    title: "",
                    holidayType: "",
                    region: [],
                  });
                  setOpenModal(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={() => handelSubmit()}>
                Submit
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>

      <Modal
        open={editModal}
        onClose={() => {
          setEditModal(false);
          setschemeErr({
            title: false,
            holidayDate: false,
            holidayType: false,
            region: false,
          });
          setValues({
            holidayDate: "",
            title: "",
            holidayType: "",
            region: [],
          });
        }}
      >
        <Box sx={messageStyle}>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", textDecoration: "underline" }}
          >
            Edit Holiday
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Name</Typography>
              <TextField
                onChange={handleChange}
                value={title}
                sx={{ width: "50%" }}
                name="title"
                label="Holiday"
                variant="outlined"
                onKeyPress={handleKeyPress}
                error={schemeErr.title}
                helperText={schemeErr.title}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Type</Typography>
              <TextField
                select
                onChange={handleChange}
                value={holidayType}
                sx={{ width: "50%" }}
                name="holidayType"
                label="Type of holiday"
                variant="outlined"
                error={schemeErr.holidayType}
                helperText={schemeErr.holidayType}
              >
                {type.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {holidayType === "REGIONAL" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6">Select Regions</Typography>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={region}
                    sx={{ width: "50%" }}
                    // label="Select Regions"
                    renderValue={(region) => {
                      const data = region.map((n) => n.name);
                      return data.join(", ");
                    }}
                    name="region"
                    error={schemeErr.region}
                    helperText={schemeErr.region}
                  >
                    {regionList.map((r) => (
                      <div key={r.value} style={{ marginLeft: "1rem" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={region.some(
                                (item) => item.name === r.name
                              )}
                            />
                          }
                          label={r.name}
                          onChange={(event) => handleRegionChange(r)}
                        />
                      </div>
                    ))}
                  </Select>
                </div>
              </>
            ) : null}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Holiday Date</Typography>
              <TextField
                type={"date"}
                onChange={handleChange}
                sx={{ width: "50%" }}
                value={holidayDate}
                name="holidayDate"
                variant="outlined"
                error={schemeErr.holidayDate}
                helperText={schemeErr.holidayDate}
              />
            </div>

            <Box sx={{ m: 2, display: "flex", justifyContent: "space-evenly" }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setEditModal(false);
                  setschemeErr({
                    title: false,
                    holidayDate: false,
                    holidayType: false,
                    region: false,
                  });
                  setValues({
                    holidayDate: "",
                    title: "",
                    holidayType: "",
                    region: [],
                  });
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={() => handelUpdate()}>
                Update
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>

      <Modal
        open={uploadModal}
        onClose={() => {
          setUploadModal(false);
          setBulkUploadData([]);
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "1rem",
            lineHeight: "5rem",
            padding: "1rem 2rem",
          }}
        >
          <Typography variant="h5" style={{ textAlign: "center" }}>
            Bulk Upload Holidays
          </Typography>

          <div
            style={{
              marginTop: "1rem",
            }}
          >
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* First Header Name Must Be <>HOLIDAY NAME<>`}
            </Typography>
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* Second Header Name Must Be <>TYPE (expected values : "REGIONAL" & "PUBLIC"<>`}
            </Typography>
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* Third Header Name Must Be <>DATE<>`}
            </Typography>
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* Fourth Header Name Must Be <>REGIONS (only in case of "REGIONAL" holidays). Comma Separated.<>`}
            </Typography>
            <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
              {`* Supported file format are ".csv .xlsx .xls"`}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="primary"
              variant="outlined"
              onClick={() => window.open(sampleFile)}
            >
              Download Sample file
            </Button>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1rem",
              paddingTop: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <Typography variant="h6" style={{ marginRight: "2rem" }}>
              Upload CSV :{" "}
            </Typography>
            <input
              type="file"
              accept=".csv, .xlsx, .xls"
              ref={ref}
              onChange={readUploadFile}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1rem",
              marginTop: "1rem",
            }}
          >
            <Button
              variant="contained"
              color="error"
              sx={{ width: "40%" }}
              onClick={() => setUploadModal(false)}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={bulkUpload}
              fullWidth
              sx={{ width: "40%" }}
              disabled={bulkUploadData.length > 0 ? false : true}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

const Holiday = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Holiday;
